import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

// FIX: Replaced `JSX.Element` with `React.ReactElement` to fix the "Cannot find namespace 'JSX'" TypeScript error.
const FeatureCard: React.FC<{ icon: React.ReactElement; title: string; children: React.ReactNode }> = ({ icon, title, children }) => (
  <div className="text-center p-6">
    <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-brand-green-light/50 dark:bg-slate-800 rounded-full text-brand-green dark:text-brand-green">
      {icon}
    </div>
    <h3 className="text-xl font-bold font-serif text-brand-dark dark:text-white mb-2">{title}</h3>
    <p className="text-slate-600 dark:text-slate-400">{children}</p>
  </div>
);

const LeafIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
);
const TruckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2 2h8a1 1 0 001-1z" /><path strokeLinecap="round" strokeLinejoin="round" d="M17 16h2a2 2 0 002-2V7a2 2 0 00-2-2h-3.5a1 1 0 00-.8.4L12 8" /></svg>
);
const SparklesIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.293 2.293a1 1 0 010 1.414L10 16l-4 4 4-4 3.293-3.293a1 1 0 011.414 0l2.293 2.293m-3.293-3.293l1.414 1.414" /></svg>
);


const About: React.FC = () => {
  const { t } = useTranslation();
  const aboutText = t('about_subtitle');
  // FIX: Split the text by the <br /><br /> tags to create separate paragraphs for better readability.
  const paragraphs = aboutText.split('<br /><br />');

  return (
    <section id="about" className="py-24 bg-brand-background dark:bg-slate-900">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-brand-dark dark:text-white">{t('about_title')}</h2>
          {/* FIX: Replaced the single <p> tag with a <div> that maps over the paragraphs to correctly render line breaks. */}
          <div className="mt-4 max-w-3xl mx-auto text-lg text-slate-600 dark:text-slate-300 space-y-6 text-left md:text-center">
            {paragraphs.map((p, index) => (
              <p key={index}>{p}</p>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <FeatureCard icon={<LeafIcon />} title={t('feature1_title')}>
            {t('feature1_text')}
          </FeatureCard>
          <FeatureCard icon={<TruckIcon />} title={t('feature2_title')}>
            {t('feature2_text')}
          </FeatureCard>
          <FeatureCard icon={<SparklesIcon />} title={t('feature3_title')}>
            {t('feature3_text')}
          </FeatureCard>
        </div>
      </div>
    </section>
  );
};

export default About;